import { useContext } from 'react';
import {
  OrganizationContext,
  OrganizationContextType,
} from '../context/OrganizationProvider';

// ----------------------------------------------------------------------

export function useOrganizationContext(): OrganizationContextType {
  const context = useContext(OrganizationContext);

  if (!context) {
    throw new Error(
      'useOrganizationContext must be used within an OrganizationProvider',
    );
  }

  return context;
}
